import { RFIconProps } from "../types";
import clsx from "clsx";

export default function BackIcon(props: RFIconProps) {
	return (
		<svg
			width="20"
			height="21"
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={clsx(props.className || "w-6 h-6")}
			id={props.id}
			onClick={props.onClick}
		>
			<path
				d="M13 3L5 10.5641L13 18"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
